module.exports = __webpack_public_path__ + "img/logowhite_oneboxbusiness-horizontal.c4473b83.png";